/**
 * Employee Web — `/me` index route mounts the dashboard.
 *
 * Phase 28.1 / DASH-04: switches the canonical landing screen from the
 * legacy `MeDashboard` (Phase 05.2 chrome refresh, fan-out across 5
 * endpoints) to the new `MeDashboardScreen` consuming the unified
 * `/api/v1/me/dashboard` aggregator + alert dismissal flow.
 *
 * Someone whose first day is still ahead gets their pre-boarding home
 * instead; the dashboard never mounts for them (it reads screens that open on
 * the first day).
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { PreboardingHome, useJoining } from "@linkhr/employee-self-service";
import { MeDashboardScreen } from "../features/dashboard/MeDashboardScreen";

export const Route = createFileRoute("/_auth/me/")({
  staticData: { breadcrumb: { labelKey: "common:nav.dashboard" } },
  component: MeDashboardRoute,
});

function MeDashboardRoute(): JSX.Element {
  return useJoining().state === "joining" ? <PreboardingHome /> : <MeDashboardScreen />;
}
